const tableConstantsEn = {
  actions: 'ACTIONS',
  rowsPerPageLabel: 'Rows per page:',
  tableColumnPages: 'Pages',
  tableColumnActions: 'Actions',
  tableRowsTotal: 'Total',
  of:'of'
};
export default tableConstantsEn;
